import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { LoadingSpinner } from 'shared/components/LoadingSpinner';
import {
  HeaderText,
  SuccessBodyHeaderContainer,
  SuccessModalBodyContainer,
} from './SuccessBody.styles';
import { Button } from '../../../../Button/Button';
import { BodyText, SmsOptInModalFooterContainer } from '../Shared/styles';

const SuccessIcon = React.lazy(() => import('shared/components/icons/SuccessIcon'));

type Props = {
  handleCloseModal: () => void;
};

export function SuccessBody({ handleCloseModal }: Props) {
  const { t } = useTranslation();

  return (
    <>
      <SuccessModalBodyContainer>
        <SuccessBodyHeaderContainer>
          <Suspense fallback={<LoadingSpinner />}>
            <SuccessIcon />
          </Suspense>

          <HeaderText as="h1">{t('account.smsOptIn.successModal.optedIn')}</HeaderText>
        </SuccessBodyHeaderContainer>

        <BodyText as="p">{t('account.smsOptIn.successModal.success')}</BodyText>
      </SuccessModalBodyContainer>
      <SmsOptInModalFooterContainer>
        <Button
          styleVariant="primary"
          label={t('account.smsOptIn.successModal.gotIt')}
          onClick={handleCloseModal}
        />
      </SmsOptInModalFooterContainer>
    </>
  );
}
export default SuccessBody;
